import React, { useEffect, useMemo, useState } from "react";
import { checkUserPermission } from "../../../common/UserPermission";
import Select from "react-select";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import config from "../../../config/config";
import axios from "axios";
import moment from "moment";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import MaterialReactTable from "material-react-table";
import { Box, Button, MenuItem } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { Field, Form, Formik } from "formik";
import { Troubleshoot } from "@mui/icons-material";
import { toastError, toastSuccess } from "../../../common/Toast";
import { ERROR_MESSAGE, SUCCESS_MESSAGE } from "../../../common/Constant";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Item from "antd/es/list/Item";
export const JobWork = (props) => {
  let selectData = [];
  const navigate = useNavigate();
  const token = localStorage.getItem("Token");
  const location = localStorage.getItem("Location");
  const loginuserid = localStorage.getItem("ID");
  const [perPageSize, setperPageSize] = useState(25);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [type, setType] = useState(0);
  // const [selectedData, setSelectedData] = useState([]);
  const [sortingId, setSortingId] = useState(1);
  const [custoptions, setCustOptions] = useState([]);
  const [sortingDirection, setSortingDirection] = useState("desc");
  const [searchtext, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [data, setData] = useState([]);
  const [selectedReceivingCheckboxIds, setselectedReceivingCheckboxIds] =
    useState("");
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [requestModalOpen, setRequestModalOpen] = useState(false);
  const [recevingSummary, setRecevingSummary] = useState();
  const [selectedoption, setSelectedOption] = useState(0);
  const [rectype, setRectype] = useState([
    {
      ID: Number,
      SalesType: String,
    },
  ]);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [customerid, setCustomerId] = useState(0);
  const [formValues, setFormValues] = useState({
    Customer: "",
    Quantity: "",
    Price: "",
  });

  const [filterTotalQuantity, setFilterTotalQuantity] = useState(0);
  const [filterTotalAmount, setFilterTotalAmount] = useState(0);

  const [totalItemAmount, setTotalItemAmount] = useState(0);
  const [totalItemQuantity, setTotalItemQuantity] = useState(0);

  const [recoptions, setRecOptions] = useState([
    {
      Id: Number,
      CompanyName: String,
      FirstName: String,
      LastName: String,
      Email: String,
      PhoneNumber: Number,
      Address1: String,
      City: String,
      StateProvince: String,
      Zip: Number,
      Country: String,
    },
  ]);
  const [receivingTypeValue, setreceivingTypeValue] = useState();
  const [supplierValue, setsupplierValue] = useState();
  const [receivingTypeID, setReceivingTypeID] = useState(0);
  const [supplierID, setSupplierID] = useState(0);
  const [startingDate, setStartingDate] = useState("");
  const [endingDate, setEndingDate] = useState("");
  const [customStartingDate, setCustomStartingDate] = useState();
  const [customEndingDate, setCustomEndingDate] = useState();
  const [showSearchBar, setShowSearchBar] = useState();
  const [status, setStatus] = useState(0);

  const [quickBookOptions, setQuickBookOptions] = useState({
    label: "All",
    value: 1,
  });

  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [quantity, setQuantity] = useState(0);
  const [total, setTotal] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  const validationSchema = Yup.object().shape({
    Quantity: Yup.string().required("Quantity is required"),
    Customer: Yup.string().required("Customer is Required"),
  });

  let PERMISSION_DELETE = "receiving-batch-delete";
  let PERMISSION_EDIT = "/manage-receiving/:id";
  let PERMISSION_ADD = "/manage-receiving";
  let PERMISSION_RECEIPT = "/receiving-receipt/:id";
  let PERMISSION_PAYBILLS = "/receiving-paybills";
  let PERMISSION_TRANSFER = "/transfer-request/:id";
  let PERMISSION_INCOMING = "/incoming-transfer/:id";
  let PERMISSION_PURCHASE = "/create-purchase-orders";
  let PERMISSION_LASTRECEIVING = "/receiving-receipt";
  let PERMISSION_BATCHRECEIVING = "/batch-receiving";
  let PERMISSION_CUSTOMFIELD = "/receiving-custom-field";

  console.log(pagination, "pagination");
  // console.log("selectedReceivingCheckboxIds", selectedReceivingCheckboxIds);
  const handleReceipt = (pID) => {
    // axios
    //     .get(
    //         `${config.receivingBaseUrl}/receivings/listofsuspendrecordByid?id=${pID}`,
    //         {
    //             headers: {
    //                 "Content-Type": "application/json;charset=UTF-8",
    //                 "Access-Control-Allow-Origin": "*",
    //                 Authorization: token,
    //             },
    //         }
    //     )
    //     .then((res) => {
    //         console.log("res from Suspended Receiving", res);
    //     })
    //     .catch((err) => {
    //         console.log(err);
    //     });
  };

  //Styles
  const selectStyles = {
    // dropdown input css
    control: (provided, state) => ({
      ...provided,
      width: "100%",
      height: "40px",
      position: "relative",
      border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
      "&:hover": {
        border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      },
    }),
    // dropdown menu css
    menu: () => ({
      boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
      position: "absolute",
      "z-index": "999",
      background: "#f8f8f8",
      color: "#000",
      width: "100%",
    }),
    // dropdown option css
    option: (provided, state) => ({
      ...provided,
      color: state.isActive ? "#000" : "#000",
      backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
      "&:hover": {
        color: "#000",
        backgroundColor: "rgba(255, 159, 67, 0.8)", // change hover color to light orange
      },
    }),
  };

  const typeoptions = [
    { value: 1, label: "Inward" },
    { value: 2, label: "Outward" },
  ];

  const onBtExport = () => {
    const workbook = XLSX.utils.book_new();

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `JobWorksDetail_.xlsx`);
  };

  // const handleUnSuspend = (pID) => {
  //   // console.log("Pid",pID);
  //   axios
  //     .get(
  //       `${config.receivingBaseUrl}/receivings/listofsuspendrecordByid?id=${pID}`,

  //       {
  //         headers: {
  //           "Content-Type": "application/json;charset=UTF-8",
  //           "Access-Control-Allow-Origin": "*",
  //           Authorization: token,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       // console.log("res from Suspended Receiving", res);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };
  // const handleRowSelected = (e) => {
  //   if (e.selectedRows.length > 0) {
  //     setSelectedRows(e.selectedRows.map((x) => x.ReceivingId));
  //     selectData[currentPage] = e.selectedRows.map((x) => x.ReceivingId);
  //     console.log(e.selectedRows.map((x) => x.ReceivingId));

  //     const selectedReceivingCheckboxIds =
  //       selectData.length > 0 ? selectData[currentPage].toString() : "";
  //     setselectedReceivingCheckboxIds(selectedReceivingCheckboxIds);
  //     console.log(selectedReceivingCheckboxIds);
  //   }
  // };

  // Get all tag data
  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder,
    startingdate,
    endingdate,
    receivingtypeid,
    supplierid,
    columnFilters,
    globalFilter,
    pagination,
    sorting,
    type,
    customerid
  ) => {
    setLoading(true);

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters;

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    const columnIndex = columns.findIndex(
      (column) => column.accessorKey === sorting[0]?.id
    );

    startingdate = startingdate === undefined ? "" : startingdate;
    endingdate = endingdate === undefined ? "" : endingdate;

    axios
      .get(
        `${
          config.jobWorksBaseUrl
        }/jobworks/jobworkslist?filtercolumnsearchtext=${FilterColumnSearchText}&pagenumber=${
          pagination.pageIndex + 1
        }&pagesize=${pagination.pageSize}&filtertext=${
          globalFilter == undefined ? "" : globalFilter
        }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&startdate=${startingdate}&enddate=${endingdate}&type=${
          type == undefined ? 0 : type
        }&customerid=${customerid == undefined ? 0 : customerid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("listofsuspendrecord", res.data.ResponseData);

        const responseData = res.data.ResponseData;

        const finalData = responseData.jobworkList.map((el) => {
          const mixdata = {
            ...el,
            items: responseData.itemList.filter(
              (itemName) => itemName.JobWorkId === el.ID
            ),
          };
          return mixdata;
        });

        const result = responseData.jobworkList.reduce(
          (accumulator, currentItem) => {
            accumulator.Total += Number(currentItem.Amount);
            accumulator.TotalQuantity += Number(currentItem.Quantity);
            return accumulator;
          },
          { Total: 0, TotalQuantity: 0 }
        );

        console.log(result, "result");
        setTotalItemAmount(result.Total);
        setTotalItemQuantity(result.TotalQuantity);

        setFilterTotalQuantity(responseData.jobworkList[0]?.SumQuantity);
        setFilterTotalAmount(responseData.jobworkList[0]?.SumTotal);

        // setData(responseData.jobworkList);
        setData(finalData);
        setTotalRows(responseData.jobworkList[0]?.TotalRecord);
        setQuantity(responseData.jobworkList[0]?.SumQuantity);
        setTotal(responseData.jobworkList[0]?.SumTotal);
        setRowCount(responseData.jobworkList[0]?.TotalRecord);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    // if (quickBookOptions?.value !== 2) {
    handleListData(
      1,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate,
      receivingTypeID,
      supplierID,
      columnFilters,
      globalFilter,
      pagination,
      sorting,
      type,
      customerid
    );
    // }
  }, [
    type,
    customerid,
    quickBookOptions,
    columnFilters,
    globalFilter,
    pagination,
    sorting,
  ]);

  const handleDeletePopup = (id, rows, field) => {
    console.log(id, "id");
    // console.log(rows.map((el) => el.original), "rows231")
    let data;

    if (field === "multipleRowInactive") {
      data = rows.map((el) => el.original.ReceivingId).join(",");
    } else {
      data = id;
    }

    const deleteRequestParam = {
      receivingids: data,
      loginuserid: loginuserid,
      locationid: location,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
    // setShowDateFilterModal(true);
    // setShowAction(false);
    setDeleteModalOpen(true);
  };

  // const contextActions = useMemo(() => {
  //     const handleDeletePopup = () => {
  //         const deleteRequestParam = {
  //             deliveriesids: selectedReceivingCheckboxIds,
  //         };
  //         localStorage.setItem(
  //             "DeleteRequestParam",
  //             JSON.stringify(deleteRequestParam)
  //         );
  //     };

  //     return (
  //         <button
  //             type="button"
  //             className="btn btn-success btn-sm pull-left "
  //             data-bs-toggle="modal"
  //             data-bs-target="#UnDeleteConfirmationModal"
  //             onClick={handleDeletePopup}
  //         >
  //             <i className="fa fa-trash fa-sm" /> Un Delete
  //         </button>
  //     );
  // }, [data, selectedRows, toggleCleared]);

  const contextActions = useMemo(() => {
    const handleDeletePopup = () => {
      const deleteRequestParam = {
        receivingids: selectedReceivingCheckboxIds,
        loginuserid: loginuserid,
        locationid: location,
      };
      localStorage.setItem(
        "DeleteRequestParam",
        JSON.stringify(deleteRequestParam)
      );
    };

    return (
      <button
        type="button"
        className="btn btn-danger btn-sm pull-left "
        data-bs-toggle="modal"
        data-bs-target="#DeleteConfirmationModal"
        onClick={handleDeletePopup}
      >
        <i className="fa fa-trash fa-sm" /> Delete
      </button>
    );
  }, [data, selectedRows, toggleCleared]);

  console.log(data, "table Data");

  // Table Data
  // const columns = [
  //   {
  //     name: "Action",
  //     cell: (row) => (
  //       <>
  //         <div class="btn-group-sm" role="group" >
  //           {row.ReceivingTypeId == 4 && row.Status == 2 ? "" : <>
  //             <Link className="btn btn-primary btn-sm btn-custom-padding"
  //               to={`/manage-receiving/${row.ReceivingId}`}
  //               style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
  //             >
  //               Edit
  //             </Link>
  //           </>
  //           }
  //           <button
  //             type="button"
  //             className="btn btn-outline-primary btn-sm dropdown-toggle btn-custom-padding"
  //             data-bs-toggle="dropdown"
  //             aria-haspopup="true"
  //             aria-expanded="false"
  //             style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
  //           >
  //           </button>
  //           <div className="dropdown-menu">
  //             {/* {row.ReceivingTypeId == 4 && row.Status == 2 ? "" : <>
  //               <li>
  //                 <Link className="dropdown-item me-3" to={`/manage-receiving/${row.ReceivingId}`}>
  //                   <i className="fa fa-edit" title="Edit"></i>&nbsp;Edit Item
  //                 </Link>
  //               </li>
  //             </>} */}
  //             <li>
  //               <Link
  //                 className="dropdown-item confirm-text"
  //                 to="#"
  //                 title="Delete"
  //                 data-bs-toggle="modal"
  //                 data-bs-target="#DeleteConfirmationModal"
  //                 onClick={() => handleDeletePopup(row.ReceivingId)}
  //               >
  //                 <i
  //                   className="fa fa-trash"
  //                   data-bs-toggle="tooltip"
  //                   title="Delete"
  //                 ></i>&nbsp;Delete Receiving
  //               </Link>
  //             </li>
  //             <li>
  //               <Link
  //                 to={`/receiving-receipt/${row.ReceivingId}`}
  //                 className="dropdown-item me-3"
  //               >
  //                 <i className="fa fa-file" aria-hidden="true"></i>&nbsp;Receipt
  //               </Link>
  //             </li>
  //           </div>
  //         </div>
  //       </>
  //     ),
  //     ignoreRowClick: true,
  //     allowOverflow: true,
  //     button: true,
  //     // minWidth: "90px",
  //     // width: "90px",
  //   },
  //   // {
  //   //   name: "Sr No",
  //   //   selector: (row, index) => index + 1,
  //   //   width: "100px",
  //   // },
  //   {
  //     name: "Date",
  //     selector: (row) => row["Date"],
  //     sortable: true,
  //     width: "110px",
  //     minWidth: "110px",
  //   },
  //   {
  //     name: "Receive Type",
  //     selector: (row) => row["ReceiveType"],
  //     sortable: true,
  //     width: "130px",
  //     minWidth: "130px",
  //   },
  //   {
  //     name: "Status",
  //     selector: (row) => row["StatusName"],
  //     sortable: true,
  //     width: "110px",
  //     minWidth: "110px",
  //   },
  //   {
  //     name: "Supplier",
  //     // selector: (row) => row["Supplier"],
  //     sortable: true,
  //     // width: "120px",
  //     cell: (row) => (
  //       <Link class="text-warning word-break-data" to={`/manage-suppliers/${row.SupplierId}`}>
  //         {row.Supplier}
  //       </Link>
  //     ),
  //     width: "110px",
  //     minWidth: "110px",
  //   },
  //   // {
  //   //   name: "Items",
  //   //   selector: (row) => row["Items"],
  //   //   sortable: true,
  //   // },
  //   {
  //     name: "Total",
  //     selector: (row) => parseFloat(row["Total"]).toFixed(2),
  //     sortable: true,
  //     right: true,
  //     width: "110px",
  //     minWidth: "110px",
  //     // width:"120px"
  //   },
  //   {
  //     name: "Amount Paid",
  //     selector: (row) => row["AmountPaid"],
  //     sortable: true,
  //     right: true,
  //     width: "130px",
  //     minWidth: "130px"
  //     // width: "150px",
  //   },
  //   // {
  //   //   name: "Last Payment Date",
  //   //   selector: row => row["LastPaymentDate"],
  //   //   sortable: true,
  //   // },
  //   {
  //     name: "Credit Applied",
  //     selector: (row) => row["CreditApplied"],
  //     sortable: true,
  //     right: true,
  //     width: "150px",
  //   },
  //   {
  //     name: "Amount Due",
  //     selector: (row) => row["AmountDue"],
  //     sortable: true,
  //     right: true,
  //     width: "130px",
  //     minWidth: "130px"
  //     // width: "150px",
  //   },
  //   {
  //     name: "Comments",
  //     // selector: (row) => row["Comments"],
  //     selector: (row) => (
  //       <div className="word-break-data">
  //         {row.Comments}
  //       </div>
  //     ),
  //     // width: "130px",
  //     minWidth: "130px"
  //     // width: "200px",
  //   },

  //   {
  //     name: "Location",
  //     // selector: "Location",
  //     selector: (row) => row.Location,
  //     // width: "150px",
  //   },
  //   // {
  //   //   name: "Unsuspend",
  //   //   width: "150px",
  //   //   cell: (row) => {
  //   //     const handleClick = () => {
  //   //       handleUnSuspend(row.ID);
  //   //     };

  //   //     return (row.Status == 1 || row.Status == 2) &&
  //   //       (row.ReceivingTypeId == 1 || row.ReceivingTypeId == 2) ? (
  //   //       <Link to={`/manage-receiving/${row.ReceivingId}`}>
  //   //         <button
  //   //           onClick={handleClick}
  //   //           className={`btn btn-sm btn-outline-${
  //   //             row.Suspended === 1 ? "danger" : "success"
  //   //           }`}
  //   //         >
  //   //           {row.Suspended === 1 ? "Suspend" : "Unsuspend"}
  //   //         </button>
  //   //       </Link>
  //   //     ) : null;
  //   //   },
  //   // },
  //   // {
  //   //   name: "Receipt",
  //   //   width: "150px",
  //   //   cell: (row) => (
  //   //     <Link to={`/receiving-receipt/${row.ReceivingId}`}>
  //   //       <button
  //   //         onClick={handleReceipt(row.ReceivingId)}
  //   //         className="btn  btn-sm btn-outline-primary btn-custom-padding"
  //   //       >
  //   //         <i className="fa fa-file"></i> Receipt
  //   //       </button>
  //   //     </Link>
  //   //   ),
  //   // },
  //   // {
  //   //   name: "Action",
  //   //   width: "100px",
  //   //   cell: (row) => (
  //   //     <>
  //   //       {row.ReceivingTypeId == 4 && row.Status == 2 ? "" : <>
  //   //         <Link className="me-3" to={`/manage-receiving/${row.ReceivingId}`}>
  //   //           <i className="fa fa-edit text-warning fa-2x" title="Edit"></i>
  //   //         </Link>
  //   //       </>}

  //   //       <Link
  //   //         className="confirm-text"
  //   //         to="#"
  //   //         title="Delete"
  //   //         data-bs-toggle="modal"
  //   //         data-bs-target="#DeleteConfirmationModal"
  //   //         onClick={() => handleDeletePopup(row.ReceivingId)}
  //   //       >
  //   //         <i
  //   //           className="fa fa-trash text-red fa-2x"
  //   //           data-bs-toggle="tooltip"
  //   //           title="Delete"
  //   //         ></i>
  //   //       </Link>
  //   //     </>
  //   //   ),
  //   // },
  // ];

  const columns = useMemo(() => [
    {
      header: "Job Work No",
      accessorKey: "ID",
      // enableGrouping: false, //do not let this column be grouped
    },
    {
      header: "Date",
      accessorKey: "Date",
      Cell: ({ row }) =>
        moment(row.original.Date).format("DD-MM-YYYY") === "Invalid date"
          ? ""
          : moment(row.original.Date).format("DD-MM-YYYY"),

      // enableGrouping: false, //do not let this column be grouped
    },
    {
      header: "Type",
      accessorKey: "JobWorkType",
      // enableGrouping: false, //do not let this column be grouped
    },
    {
      header: "Customer Name",
      accessorKey: "Customername",
      // enableGrouping: false, //do not let this column be grouped
    },

    {
      header: "Item",
      accessorKey: "Item",
      Cell: ({ row }) => (
        <div>
          {row.original?.items.map((el) => {
            return <p>{el.Name}</p>;
          })}
        </div>
      ),
    },

    {
      header: "Quantity",
      accessorKey: "Quantity",
      // Cell: ({ row }) =>
      //   row.original.Quantity > 0
      //     ? parseFloat(row.original.Quantity).toFixed(2)
      //     : 0,
      Cell: ({ row }) => (
        <div>
          {row.original?.items.map((el) => {
            return <p>{parseFloat(el.Quantity).toFixed(2)}</p>;
          })}
        </div>
      ),
      Footer: () => (
        <Box>
          Total Quantity:{" " + parseFloat(filterTotalQuantity).toFixed(2)}
        </Box>
      ),
    },

    {
      header: "Total",
      // accessorKey: "Amount",
      // Cell: ({ row }) => parseFloat(row.original.Amount).toFixed(2),
      Cell: ({ row }) => (
        <div>
          {row.original?.items.map((el) => {
            return <p>{parseFloat(el.Total).toFixed(2)}</p>;
          })}
        </div>
      ),
      Footer: () => (
        <Box>Total Amount:{" " + parseFloat(filterTotalAmount).toFixed(2)}</Box>
      ),
    },
    {
      header: "Created Date",
      accessorKey: "CreatedDate",
      Cell: ({ row }) =>
        moment(row.original.CreatedDate).format("DD-MM-YYYY") === "Invalid date"
          ? ""
          : moment(row.original.CreatedDate).format("DD-MM-YYYY"),
      // Cell: ({ row }) => moment(row.original.CreatedDate).format("YYYY-MM-DD"),
    },
  ]);

  const handleChangeStatus = (e) => {
    setStatus(e?.value);
  };

  const handleSelect = (e) => {
    setSelectedOption(e?.value);
  };

  // console.log(formValues,"formvalues")

  const handleSubmit = (values) => {
    let data = {
      id: 0,
      customerid: values.Customer,
      price: values.Price,
      quantity: values.Quantity,
      total: Number(values.Price) * Number(values.Quantity),
    };
    setLoading(true);
    axios
      .post(`${config.jobWorksBaseUrl}/jobworks/requestjobworksupsert`, data, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("Receving Types", res.data.ResponseData);
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseData > 0) {
          toastSuccess(SUCCESS_MESSAGE);
          navigate("/jobworks");
        } else {
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
        // setRectype(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //   if (hiddenColumns.includes(columnName)) {
  //     setHiddenColumns(hiddenColumns.filter((column) => column !== columnName));
  //   } else {
  //     setHiddenColumns([...hiddenColumns, columnName]);
  //   }
  // }
  // // generate new columns according to hiddenColumns data and pass it as datatable column
  // const filteredColumns = columns.filter(
  //   (column) => !hiddenColumns.includes(column.name.replace(/\s+|-|\/|#/g, ""))
  // );

  // const handlePerRowsChange = async (page, newPerPage) => {
  //   setperPageSize(newPerPage);
  //   setCurrentPage(page);
  //   handleListData(
  //     page,
  //     newPerPage,
  //     searchtext,
  //     sortingId,
  //     sortingDirection,
  //     startingDate,
  //     endingDate,
  //     receivingTypeID,
  //     supplierID
  //   );
  // };

  // const handlePageChange = (page) => {
  //   setCurrentPage(page);
  //   handleListData(
  //     page,
  //     perPageSize,
  //     searchtext,
  //     sortingId,
  //     sortingDirection,
  //     startingDate,
  //     endingDate,
  //     receivingTypeID,
  //     supplierID
  //   );
  // };

  // const handleSort = (e, sortingDirection) => {
  //   setSortingId(e.id);
  //   setSortingDirection(sortingDirection);
  //   handleListData(
  //     1,
  //     perPageSize,
  //     searchtext,
  //     e.id,
  //     sortingDirection,
  //     startingDate,
  //     endingDate,
  //     receivingTypeID,
  //     supplierID
  //   );
  // };

  // fatch and display data on page load ===> ashish
  useEffect(() => {
    axios
      .get(`${config.customersBaseUrl}/customers/customerdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        setCustOptions(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const optionscustomer = custoptions.map((option) => ({
    value: option.Id,
    label:
      option.CompanyName +
      "(" +
      (option.FirstName + " " + option.LastName) +
      ")",

    address: option.Address1,

    email: option.Email,
  }));

  const options = [
    { label: "All", value: 1 },
    { label: "Today", value: 7 },
    { label: "Last Day", value: 8 },
    { label: "Current Week", value: 4 },
    { label: "Last Week", value: 3 },
    { label: "Current Month", value: 6 },
    { label: "Last Month", value: 5 },
    { label: "Custom", value: 2 },
  ];

  const handleChangeCustomStartingDate = (event) => {
    console.log("event starting ==> ", event.target.value);
    setCustomStartingDate(event.target.value);
    setStartingDate(event.target.value);
  };

  const handleChangeCustomEndingDate = (event) => {
    // console.log("event ending ==> ", event.target.value);
    setCustomEndingDate(event.target.value);
    setEndingDate(event.target.value);
  };

  const supplierDropDown = recoptions.map((option) => ({
    value: option.ID,
    // label: option.FirstName + " " + option.LastName,
    label:
      option.CompanyName +
      " (" +
      (option.FirstName + " " + option.LastName) +
      ")",
    address: option.Address,
  }));

  const handleQuickBookChange = (event) => {
    // event?.value !== 2 && handleSearchAccordingToDate();

    setQuickBookOptions(event);

    console.log(event, "quick book data");

    // All Condition
    if (event?.value == 1) {
      setStartingDate("");
      setEndingDate("");
    }
    // Custom Condition
    else if (event?.value == 2) {
      setStartingDate(customStartingDate);
      setEndingDate(customEndingDate);
    }
    // Last Week Condition
    else if (event?.value == 3) {
      const lastWeekStartDate = moment()
        .subtract(1, "week")
        .startOf("week")
        .format("YYYY-MM-DD");
      const lastWeekEndDate = moment()
        .subtract(1, "week")
        .endOf("week")
        .format("YYYY-MM-DD");

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Current Week Condition
    else if (event?.value == 4) {
      const lastWeekStartDate = moment().startOf("week").format("YYYY-MM-DD");
      const lastWeekEndDate = moment().endOf("week").format("YYYY-MM-DD");
      console.log(
        "lastWeekStartDate: " + lastWeekStartDate,
        "| " + "lastWeekEndDate" + lastWeekEndDate
      );

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Last Month Condition
    else if (event?.value == 5) {
      const lastMonthStartDate = moment()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
      const lastMonthEndDate = moment()
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD");

      setStartingDate(lastMonthStartDate);
      setEndingDate(lastMonthEndDate);
    }
    // Current Month Condition
    else if (event?.value == 6) {
      const currentFirstDate = moment().startOf("month").format("YYYY-MM-DD");
      const currentLastDate = moment().endOf("month").format("YYYY-MM-DD");

      setStartingDate(currentFirstDate);
      setEndingDate(currentLastDate);
    } else if (event?.value == 7) {
      setStartingDate(moment().startOf("day").format("YYYY-MM-DD"));
      setEndingDate(moment().startOf("day").format("YYYY-MM-DD"));
    } else if (event?.value == 8) {
      const yesterday = moment().subtract(1, "days").format("YYYY-MM-DD");
      setStartingDate(yesterday);
      setEndingDate(yesterday);
    } else {
      setStartingDate("");
      setEndingDate("");
    }
  };

  // useEffect(() => {
  //   if (quickBookOptions?.value == 1) {
  //     setStartingDate("");
  //     setEndingDate("");
  //   }
  //   // Custom Condition
  //   // else if (quickBookOptions?.value == 2) {
  //   //   setStartingDate(customStartingDate);
  //   //   setEndingDate(customEndingDate);
  //   // }
  //   // Last Week Condition
  //   else if (quickBookOptions?.value == 3) {
  //     const lastWeekStartDate = moment()
  //       .subtract(1, "week")
  //       .startOf("week")
  //       .format("YYYY-MM-DD");
  //     const lastWeekEndDate = moment()
  //       .subtract(1, "week")
  //       .endOf("week")
  //       .format("YYYY-MM-DD");

  //     setStartingDate(lastWeekStartDate);
  //     setEndingDate(lastWeekEndDate);
  //   }
  //   // Current Week Condition
  //   else if (quickBookOptions?.value == 4) {
  //     const currentWeekStartDate = moment()
  //       .startOf("week")
  //       .format("YYYY-MM-DD");
  //     const currentWeekEndDate = moment().endOf("week").format("YYYY-MM-DD");

  //     setStartingDate(currentWeekStartDate);
  //     setEndingDate(currentWeekEndDate);
  //   }
  //   // Last Month Condition
  //   else if (quickBookOptions?.value == 5) {
  //     const lastMonthStartDate = moment()
  //       .subtract(1, "month")
  //       .startOf("month")
  //       .format("YYYY-MM-DD");
  //     const lastMonthEndDate = moment()
  //       .subtract(1, "month")
  //       .endOf("month")
  //       .format("YYYY-MM-DD");

  //     setStartingDate(lastMonthStartDate);
  //     setEndingDate(lastMonthEndDate);
  //   }
  //   //current Month
  //   else if (quickBookOptions?.value == 6) {
  //     const currentFirstDate = moment().startOf("month").format("YYYY-MM-DD");
  //     const currentLastDate = moment().endOf("month").format("YYYY-MM-DD");

  //     setStartingDate(currentFirstDate);
  //     setEndingDate(currentLastDate);
  //   } else {
  //     setStartingDate("");
  //     setEndingDate("");
  //   }
  // }, [quickBookOptions]);

  const handleSearchAccordingToDate = () => {
    handleListData(
      1,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate,
      receivingTypeID,
      supplierID,
      columnFilters,
      globalFilter,
      pagination,
      sorting,
      type
    );
  };

  const handleChangeReceivingType = (event) => {
    setType(event?.value);
  };

  const handleChangeSupplier = (event) => {
    console.log(event);
    setsupplierValue(event);
    setSupplierID(event?.value);
  };

  let receivingTypeDropdownOption = [];
  const ReceivingTypeDropdown = rectype.map((u, i) => {
    receivingTypeDropdownOption[i] = { label: u.ReceivingsType, value: u.ID };
  });

  // const supplierDropDown = recoptions.map((option) => ({
  //   value: option.ID,
  //   // label: option.FirstName + " " + option.LastName,
  //   label:
  //     option.CompanyName +
  //     " (" +
  //     (option.FirstName + " " + option.LastName) +
  //     ")",
  //   address: option.Address,
  // }));

  const statusoption = [
    { label: "All", value: 0 },
    { label: "Completed", value: 2 },
    { label: "Paid", value: 4 },
    { label: "Pending", value: 1 },
    { label: "Rejected", value: 3 },
  ];

  // const downloadPDF = (rows, field) => {
  //   let newData = [];
  //   if (field === "selectedrow") {
  //     newData = rows.map((row) => row.original);
  //   } else if (field === "alldata") {
  //     newData = data;
  //   }
  //   console.log(newData, "newData");

  //   setLoading(true);
  //   var doc = new jsPDF("p", "pt", "a4");

  //   // Add the header
  //   let headerElement = document.querySelector("#header");
  //   let clonedHeader = headerElement.cloneNode(true);
  //   clonedHeader.style.fontSize = `10px`;
  //   clonedHeader.style.width = "560px";
  //   clonedHeader.style.margin = "1rem";

  //   let content = "";
  //   let startIndex = 1;
  //   let endIndex = 25;

  //   for (var i = 1; i <= Math.ceil(newData.length / 25); i++) {
  //     if (i == 1) {
  //       clonedHeader.style.marginTop = "2rem";
  //     }
  //     if (i > 1) {
  //       clonedHeader.style.marginTop = "2.5rem";
  //     }
  //     // Printing header
  //     content += " " + clonedHeader.outerHTML;

  //     // Printing table body
  //     content +=
  //       '<table style="font-size: 8px; margin-left: 1rem; margin-top: 2rem; width: 560px; border: 1px solid #f5f5f5">';
  //     content +=
  //       "<thead><tr style='margin-bottom: 5px'>" +
  //       '<th style="padding: 7px;">Job Work No</th>' +
  //       '<th style="padding: 7px;">Date</th>' +
  //       '<th style="padding: 7px;">JobWorkType</th>' +
  //       '<th style="padding: 7px;">Customername</th>' +
  //       '<th style="padding: 7px;">item</th>' +
  //       '<th style="padding: 7px;">Total Quantity</th>' +
  //       '<th style="padding: 7px;">Total</th>' +
  //       '<th style="padding: 7px;">CreatedDate</th>' +
  //       "</tr></thead>";
  //     content += "<tbody>";

  //     // Loop for printing items based on endIndex
  //     for (let index = startIndex; index <= endIndex; index++) {
  //       if (index <= newData.length) {
  //         content +=
  //           "<tr>" +
  // '<td style="font-size: 7px; padding: 7px;">' +
  // index +
  // "</td>" +
  //           '<td style="font-size: 7px; padding: 7px;">' +
  //           newData[index - 1].ID +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px;">' +
  //           (moment(newData[index - 1].Date).format("DD-MM-YYYY") ===
  //           "Invalid date"
  //             ? ""
  //             : moment(newData[index - 1].Date).format("DD-MM-YYYY")) +
  //           "</td>" +
    // '<td style="font-size: 7px; padding: 7px;">' +
    // newData[index - 1].JobWorkType +
    // "</td>" +
  //           '<td style="font-size: 7px; padding: 7px;">' +
  //           newData[index - 1].Customername +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px;">' +
  //           newData[index - 1].items.map((el) => "<div>" + el.Name + "</div>") +
  //           "</td>" +
  //           // '<td style="font-size: 7px; padding: 7px;">' +
  //           // newData[index - 1].items.map((el) => "<p>" + el.Name + "</p>") .join("") +
  //           // "</td>" +

  //         '<td style="font-size: 7px; padding: 7px;">' +
  //           newData[index - 1].Quantity +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px;">' +
  //           Number(newData[index - 1].Amount).toFixed(2) +
  //           "</td>" +
  //           '<td style="font-size: 7px; padding: 7px;">' +
  //           (moment(newData[index - 1].CreatedDate).format("DD-MM-YYYY") ===
  //           "Invalid date"
  //             ? ""
  //             : moment(newData[index - 1].CreatedDate).format("DD-MM-YYYY")) +
  //           "</td>" +
  //           "</tr>";
  //       }

  //       if (index % 25 == 0) {
  //         startIndex = startIndex + 25;
  //         endIndex = endIndex + 25;
  //         break;
  //       }
  //     }

  //     content += "</tbody>";
  //     content +=
  //       "<tfoot><tr style='margin-bottom: 5px'>" +
  //       '<td style="padding: 7px;"></td>' +
  //       '<td style="padding: 7px;"></td>' +
  //       '<td style="padding: 7px;"></td>' +
  //       '<td style="padding: 7px;"></td>' +
  //       '<td style="padding: 7px;">Total Qty:' +
  //       // totalItemQuantity +
  //       parseFloat(filterTotalQuantity).toFixed(2) +
  //       "</td>" +
  //       '<td style="padding: 7px;">Total:' +
  //       // totalItemAmount +
  //       parseFloat(filterTotalAmount).toFixed(2) +
  //       "</td>" +
  //       '<td style="padding: 7px;"></td>' +
  //       "</tr></tfoot>";

  //     content += "</table>";

  //     content +=
  //       '<div style="text-align: center; width: 560px">' +
  //       '<p style= "text-align: center; margin-top: 1.3rem; font-size: 9px; font-weight: bold;">' +
  //       i +
  //       "</p>" +
  //       "</div>";
  //   }

  //   // Printing page
  //   doc.html(content, {
  //     callback: function (pdf) {
  //       pdf.save("JobWork.pdf");
  //       setLoading(false);
  //     },
  //   });
  // };
  const generateHeader = () => {
    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = "10px";
    clonedHeader.style.width = "560px";
    clonedHeader.style.margin = "1rem";

    return clonedHeader.outerHTML;
  };

  const generatePageContent = (headerContent, tableContent, footerContent) => {
    return `${headerContent}${tableContent}${footerContent}`;
  };

  const generateFooter = (filterTotalQuantity, filterTotalAmount) => {
    return `<tfoot><tr style='margin-bottom: 5px'>
      <td style="padding: 6px;"></td>
      <td style="padding: 6px;"></td>
      <td style="padding: 6px;"></td>
      <td style="padding: 6px;"></td>
      <td style="padding: 6px;"></td>
      <td style="padding: 6px;"></td>
      <td style="padding: 6px;">Qty: ${parseInt(filterTotalQuantity).toFixed(2)}</td>
      <td style="padding: 6px;">Total: ${parseInt(filterTotalAmount).toFixed(2)}</td>
      <td style="padding: 6px;"></td>
    </tr></tfoot></table></div>`;
  };

  const generateTable = (data, startIndex, endIndex, rowsPerPage) => {
    let tableContent =
      "<table style='font-size: 8px; margin-left: 1rem; width: 560px; border: 1px solid #f5f5f5'>";
    tableContent += "<thead><tr style='margin-bottom: 5px'>";

    // Add table headers

    tableContent += '<th style="padding: 6px;">No</th>';
    tableContent += '<th style="padding: 6px;">Job Work No</th>';
    tableContent += '<th style="padding: 6px;">Date</th>';
    tableContent += '<th style="padding: 6px; width:60px;">Job Work Type</th>';
    tableContent += '<th style="padding: 6px;">Customer</th>';
    tableContent += '<th style="padding: 6px;">item</th>';
    tableContent += '<th style="padding: 6px;">Quantity</th>';
    tableContent += '<th style="padding: 6px;">Total</th>';
    tableContent += '<th style="padding: 6px;">Created Date</th>';
    tableContent += "</tr></thead>";
    tableContent += "<tbody>";

    // Add table rows
    for (let index = startIndex; index <= endIndex; index++) {
      if (index <= data.length) {
        
        // Add row data
        tableContent += `<tr>
          <td style="font-size: 6px; padding: 6px;">${index}</td>

          <td style="font-size: 6px; padding: 6px;">${
            data[index - 1].ID
          }</td>

          <td style="font-size: 6px; padding: 6px;">${moment(
           moment( data[index - 1].Date) ).format("DD-MM-YYYY") === "Invalid date" ? "" : moment( data[index - 1].Date).format("DD-MM-YYYY") }
           </td>

          <td style="font-size: 6px; padding: 6px;">
          ${data[index - 1].JobWorkType}
          </td>

          <td style="font-size: 6px; padding: 6px;">
          ${data[index - 1].Customername}
          </td>

          <td style="font-size: 6px; padding: 6px;">
          ${data[index - 1]?.items?.map(
            (el) => "<div>" + el?.Name + "</div>"
          ).join('')}
          </td>

          <td style="font-size: 6px; padding: 6px;">
          ${data[index - 1]?.items?.map(
            (el) => "<div>" + el?.Quantity + "</div>"
          ).join('')}
          </td>

          <td style="font-size: 6px; padding: 6px;">
          ${(data[index - 1].Amount == 0 ? "" : data[index - 1].Amount)}
          </td>

          <td style="font-size: 6px; padding: 6px;">${moment(
            moment( data[index - 1].CreatedDate) ).format("DD-MM-YYYY") === "Invalid date" ? "" : moment( data[index - 1].CreatedDate).format("DD-MM-YYYY") }</td>
          </td>
        </tr>`;
      }
    }


    tableContent += "</tbody>";
    // tableContent += generateBottomContent(); // Add bottom content
    return tableContent;
  };

  const downloadPDF = (rows, field, rowsPerPage = 16) => {
    let newData = [];
    if (field === "selectedrow") {
      newData = rows.map((row) => row.original);
    } else if (field === "alldata") {
      newData = data;
    }

    setLoading(true);
    var doc = new jsPDF("p", "pt", "a4");

    let content = "";
    let startIndex = 1;
    let endIndex = rowsPerPage;
    for (var i = 1; i <= Math.ceil(newData.length / rowsPerPage); i++) {
      content += "<div style='height: 840px; border: 1px solid white'>";
      const headerContent = generateHeader();
      const tableContent = generateTable(
        newData,
        startIndex,
        endIndex,
        rowsPerPage
      );
      const footerContent = generateFooter(
        filterTotalQuantity,
        filterTotalAmount
      );

      // Concatenate content for each page
      content += generatePageContent(
        headerContent,
        tableContent,
        footerContent
      );

      startIndex += rowsPerPage;
      endIndex += rowsPerPage;
    }

    // Printing page
    doc.html(content, {
      callback: function (pdf) {
        pdf.save("JobWork.pdf");
        setLoading(false);
      },
    });
  };

  const handleExportRows = (rows) => {
    console.log(
      rows.map((row) => row.original),
      "selected row"
    );
    // csvExporter.generateCsv(rows.map((row) => row.original));

    const workbook = XLSX.utils.book_new();
    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(rows.map((row) => row.original));
    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `jobWork_.xlsx`);
  };

  // useEffect(() => {
  //   handleListData(
  //     1,
  //     perPageSize,
  //     searchtext,
  //     sortingId,
  //     sortingDirection,
  //     startingDate,
  //     endingDate,
  //     receivingTypeID,
  //     supplierID
  //   );
  // }, []);
  const handleCustomer = (e) => {
    setCustomerId(e?.value);
  };

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row" style={{ marginTop: "5px" }}>
              <h3 className="page-title">Job Works</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                {/* <li className="breadcrumb-item">
                    <Link to="/receiving">Receiving List</Link>
                  </li> */}
                <li className="breadcrumb-item active">Job Works List</li>
              </ul>
            </div>
          </div>
          <div
            // className="btn-group ms-2 dropdown"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            {checkUserPermission("/manage-jobworks") ? (
              <div className="me-2">
                <Link
                  // className="btn btn-added pull-right btn-sm"
                  className="btn btn-primary btn-sm pull-right"
                  style={{ width: "max-content" }}
                  to={`/manage-jobworks`}
                >
                  <i className="fa fa-plus me-2 lg"></i>
                  New Job Works
                </Link>
              </div>
            ) : (
              ""
            )}
            {checkUserPermission("jobwork-request") ? (
              <div className="me-2">
                <button
                  // className="btn btn-added pull-right  btn-sm"
                  className="btn btn-primary btn-sm pull-right"
                  style={{ width: "max-content" }}
                  data-bs-toggle="modal"
                  data-bs-target="#NewRequestDataModal"
                  // onClick={()=>setRequestModalOpen(true)}
                >
                  <i className="fa fa-plus me-2 lg"></i>
                  New Request
                </button>
              </div>
            ) : (
              ""
            )}
            <div className="me-2">
              <button
                className="btn btn-primary btn-sm pull-right"
                style={{ width: "max-content" }}
                onClick={onBtExport}
              >
                Export to Excel
              </button>
            </div>
            {/* <div className="btn-group btn-group-sm pull-right me-2">
              <button
                type="button"
                className="btn btn-outline-dark dropdown-toggle me-1  btn-sm"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                style={{ borderRadius: "5px" }}
              >
                More
              </button>

              <ul className="dropdown-menu">
                

                {checkUserPermission(PERMISSION_TRANSFER) ? (
                  <li>
                    <Link
                      to="/suspended-receiving/1"
                      title="Suspended receiving"
                      className="dropdown-item"
                    >
                      <i className="far fa-file fs-6 me-1"></i> Transfer Request
                    </Link>
                  </li>
                ) : (
                  ""
                )}

                {checkUserPermission(PERMISSION_INCOMING) ? (
                  <li>
                    <Link
                      to="/suspended-receiving/0"
                      title="Suspended receiving"
                      className="dropdown-item"
                    >
                      <i className="far fa-file fs-6 me-1"></i> Incoming
                      Transfers
                    </Link>
                  </li>
                ) : (
                  ""
                )}

                {checkUserPermission(PERMISSION_PURCHASE) ? (
                  <li>
                    <Link
                      to="/create-purchase-orders"
                      title="Create Purchase Order"
                      className="dropdown-item"
                    >
                      <i className="far fa-file fs-6 me-1"></i> Create Purchase
                      Orders
                    </Link>
                  </li>
                ) : (
                  ""
                )}
                {checkUserPermission(PERMISSION_LASTRECEIVING) ? (
                  <li>
                    <Link
                      // type="button"
                      className="dropdown-item"
                      data-bs-target="#LookupReceiptModal"
                      data-bs-toggle="modal"
                    >
                      <i className="far fa-file fs-6 me-1"></i> Lookup Receipt
                    </Link>
                  </li>
                ) : (
                  ""
                )}
             

                {checkUserPermission(PERMISSION_LASTRECEIVING) ? (
                  <li>
                    <Link
                      to="/receiving-receipt"
                      title="Suspended receiving"
                      className="dropdown-item"
                    >
                      <i className="far fa-file fs-6 me-1"></i> Show Last
                      Receiving
                    </Link>
                  </li>
                ) : (
                  ""
                )}

                {checkUserPermission(PERMISSION_BATCHRECEIVING) ? (
                  <li>
                    <Link
                      to="/batch-receiving"
                      title="Suspended receiving"
                      className="dropdown-item"
                    >
                      <i className="fas fa-shopping-bag fs-6 me-1"></i> Batch
                      Receiving
                    </Link>
                  </li>
                ) : (
                  ""
                )}

                {checkUserPermission(PERMISSION_CUSTOMFIELD) ? (
                  <li>
                    <Link
                      to={"/receiving-custom-field"}
                      className="dropdown-item"
                    >
                      <i className="fas fa-wrench fs-6 me-1"></i> Custom Field
                      Configuration
                    </Link>{" "}
                  </li>
                ) : (
                  ""
                )}
              </ul>
            </div> */}

            {/* <div className="btn-group btn-group-sm pull-right me-2">
                <button
                  type="button"
                  className="btn btn-outline-primary dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  style={{ borderRadius: "5px" }}
                >
                  <i className="fa fa-cog"></i> &nbsp;
                </button>
                <div className="dropdown-menu">
                  {columns.map((column) =>
                    // omit Action column
                    column.name.replace(/\s+|-|\/|#/g, "") !== "Action" ? (
                      <div
                        key={column.name.replace(/\s+|-|\/|#/g, "")}
                        className="form-check ms-2 mt-1"
                      >
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`checkbox-${column.name.replace(
                            /\s+|-|\/|#/g,
                            ""
                          )}`}
                          value={column.name.replace(/\s+|-|\/|#/g, "")}
                          checked={
                            !hiddenColumns.includes(
                              column.name.replace(/\s+|-|\/|#/g, "")
                            )
                          } // check all checkboxes which are not include in hiddenColumns
                          onChange={() =>
                            handleCheckboxChange(
                              column.name.replace(/\s+|-|\/|#/g, "")
                            )
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`checkbox-${column.name.replace(
                            /\s+|-|\/|#/g,
                            ""
                          )}`}
                        >
                          {column.name}
                        </label>
                      </div>
                    ) : (
                      ""
                    )
                  )}
                </div>
              </div> */}
          </div>

          {/* summnery of recieving data */}

          {/* <div className="row"> */}
          {/* <div className="col-lg-3 col-sm-3 col-12">
              <div className="dash-widget mb-0">
                <div className="dash-widgetimg">
                  <span>
                    <img src={Dash1} alt="img" />
                  </span>
                </div>
                <div className="dash-widgetcontent">
                  <h5>
                    $
                    <span className="counters">
                      <CountUp end={recevingSummary?.PurchaseAmount} />
                     
                    </span>
                  </h5>
                  <h6>
                    {recevingSummary?.PurchaseCount !== 0
                      ? recevingSummary?.PurchaseCount
                      : 0}{" "}
                    Purchase Orders
                  </h6>
               
                </div>
              </div>
            </div> */}
          {/* <div className="col-lg-2 col-sm-4 col-12">
                <div className="dash-widget dash1">
                  <div className="dash-widgetimg">
                    <span>
                      <img src={Dash2} alt="img" />
                    </span>
                  </div>
                  <div className="dash-widgetcontent">
                    <h5>
                      $
                      <span className="counters">
                        <CountUp end={recevingSummary.UnbilledActivityAmount} />
                      </span>
                    </h5>
                    <h6>{recevingSummary.UnbilledActivityCount} Unbilled Activity </h6>
                  </div>
                </div>
              </div> */}
          {/* <div className="col-lg-3 col-sm-3 col-12">
              <div className="dash-widget dash2  mb-0">
                <div className="dash-widgetimg">
                  <span>
                    <img src={Dash3} alt="img" />
                  </span>
                </div>
                <div className="dash-widgetcontent">
                  <h5>
                    $
                    <span className="counters">
                      <CountUp end={recevingSummary?.OverdueAmount} />
                    </span>
                  </h5>
                  <h6>
                    {recevingSummary?.OverdueCount !== 0
                      ? recevingSummary?.OverdueCount
                      : 0}{" "}
                    Overdue
                  </h6>
                </div>
              </div>
            </div> */}
          {/* <div className="col-lg-3 col-sm-3 col-12">
              <div className="dash-widget dash3  mb-0">
                <div className="dash-widgetimg">
                  <span>
                    <img src={Dash4} alt="img" />
                  </span>
                </div>
                <div className="dash-widgetcontent">
                  <h5>
                    $
                    <span className="counters">
                      <CountUp end={recevingSummary?.UnbilledActivityAmount} />
                    </span>
                  </h5>
                  <h6>
                    {recevingSummary?.UnbilledActivityCount !== 0
                      ? recevingSummary?.UnbilledActivityCount
                      : 0}{" "}
                    Open Bill
                  </h6>
                </div>
              </div>
            </div> */}
          {/* <div className="col-lg-3 col-sm-3 col-12">
              <div className="dash-widget dash2 mb-0">
                <div className="dash-widgetimg">
                  <span>
                    <img src={Dash2} alt="img" />
                    
                  </span>
                </div>
                <div className="dash-widgetcontent">
                  <h5>
                    $
                    <span className="counters">
                      <CountUp end={recevingSummary?.LastPaidCountAmount} />
                    </span>
                  </h5>
                  <h6>
                    {recevingSummary?.LastPaidCount !== 0
                      ? recevingSummary?.LastPaidCount
                      : 0}{" "}
                    Paid Last 30 Days
                  </h6>
                </div>
              </div>
            </div> */}
          {/* </div> */}

          {/* filteration of table data */}
          <div className="row">
            <div className="d-flex mb-3">
              {/* <div className="pr-2 col-lg-2 col-md-6 col-sm-12">
                  Search:
                  <input
                    type="search"
                    placeholder="Search..."
                    className=" form-control form-control-sm"
                    onChange={ChangeFilterText}
                    value={searchtext}
                    width="1rem"
                  />
                </div> */}
              <div className="col-md-2 mx-2 mt-1">
                Date Filter:
                <Select
                  defaultValue={quickBookOptions}
                  onChange={(event) => {
                    handleQuickBookChange(event);
                  }}
                  options={options}
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  isClearable={true}
                  // hideSelectedOptions={true}
                  styles={selectStyles}
                  className="custom-search-select"
                />
              </div>
              {quickBookOptions?.value == 2 && (
                <>
                  <div className="col-md-2">
                    Custom Start Date:
                    <input
                      type="date"
                      className="form-control form-control-sm mt-1"
                      id="StartDate"
                      name="StartDate"
                      onChange={(event) =>
                        handleChangeCustomStartingDate(event)
                      }
                    />
                  </div>
                  <div className="col-md-2">
                    Custom End Date:
                    <input
                      type="date"
                      className="form-control form-control-sm mt-1"
                      id="EndDate"
                      name="EndDate"
                      onChange={(event) => handleChangeCustomEndingDate(event)}
                    />
                  </div>
                  <div className="pr-2 col-lg-1 col-md-6 col-sm-12 mt-4">
                    <button
                      className="btn btn-dark btn-sm"
                      onClick={() => handleSearchAccordingToDate()}
                    >
                      {" "}
                      Search{" "}
                    </button>
                  </div>
                </>
              )}

              {/* <div className="p-3 col-lg-1 col-md-6 col-sm-12 mt-4">
                    <button
                      className="btn btn-dark"
                      onClick={() => handleSearchAccordingToDate()}
                    >
                      {" "}
                      Search{" "}
                    </button>
                  </div> */}
              <div className="col-md-2 mt-1 mx-2">
                Type:
                <Select
                  defaultValue={type}
                  onChange={(event) => {
                    handleChangeReceivingType(event);
                  }}
                  options={typeoptions}
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  isClearable={true}
                  styles={selectStyles}
                  className="custom-search-select"
                />
              </div>
              <div className="col-md-3 mt-1 ml-2">
                Customer:
                <Select
                  defaultValue={customerid}
                  onChange={(event) => {
                    handleCustomer(event);
                  }}
                  options={optionscustomer}
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  isClearable={true}
                  styles={selectStyles}
                  className="custom-search-select"
                />
              </div>
            </div>
            {/* <div className="col-lg-10 col-md-10 col-sm-12">
              </div> */}
          </div>

          {/* Customer list */}
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                {/* <DataTable
                    title="Receiving List"
                    columns={filteredColumns}
                    data={data}
                    // progressPending={loading}
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationDefaultPage={currentPage}
                    onChangeRowsPerPage={(e) => {
                      handlePerRowsChange(1, e);
                    }}
                    onChangePage={handlePageChange}
                    highlightOnHover
                    striped
                    responsive
                    paginationRowsPerPageOptions={[25, 50, 100, 500]}
                    persistTableHead
                    selectableRows
                    sortServer
                    onSort={handleSort}
                    contextActions={contextActions}
                    // contextActions={contextActions}
                    onSelectedRowsChange={handleRowSelected}
                    clearSelectedRows={toggleCleared}
                    dense
                    paginationPerPage={perPageSize}
                  /> */}

                {/* Receipt */}
                <div className="container" style={{ display: "none" }}>
                  <div className="col-md-12 text-center" id="header">
                    <h5>Jarkan</h5>
                    <div className="fw-bold">Job Work</div>
                    <div className="row">
                      {(customStartingDate || customEndingDate) && (
                        <>
                          <p>
                            Date: {customStartingDate} to {customEndingDate}
                          </p>
                        </>
                      )}
                    </div>
                  </div>
                  <hr />
                </div>

                <MaterialReactTable
                  columns={columns}
                  data={data}
                  // positionPagination='top'
                  enableColumnResizing
                  enableGrouping
                  enableStickyHeader
                  enableStickyFooter
                  enableRowSelection
                  enableColumnOrdering
                  enableRowActions
                  renderRowActionMenuItems={({ row }) => [
                    checkUserPermission(PERMISSION_EDIT) ? (
                      <MenuItem
                        key="edit"
                        onClick={() =>
                          navigate(`/manage-jobworks/${row.original.ID}`)
                        }
                      >
                        Edit
                      </MenuItem>
                    ) : (
                      ""
                    ),
                    checkUserPermission(PERMISSION_EDIT) ? (
                      <MenuItem
                        key="edit"
                        onClick={() =>
                          navigate(`/jobworks-receipt/${row.original.ID}`)
                        }
                      >
                        Receipt
                      </MenuItem>
                    ) : (
                      ""
                    ),
                  ]}
                  renderTopToolbarCustomActions={({ table }) => (
                    <Box
                      sx={{
                        display: "flex",
                        gap: "1rem",
                        p: "0.5rem",
                        flexWrap: "wrap",
                      }}
                    >
                      {console.log(table, "tables")}
                      <Button
                        size="small"
                        color="primary"
                        //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                        onClick={onBtExport}
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                      >
                        Export All In Excel
                      </Button>
                      <Button
                        size="small"
                        disabled={
                          !table.getIsSomeRowsSelected() &&
                          !table.getIsAllRowsSelected()
                        }
                        //only export selected rows
                        onClick={() =>
                          handleExportRows(table.getSelectedRowModel().rows)
                        }
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                      >
                        Export Selected Rows in Excel
                      </Button>
                      <Button
                        size="small"
                        color="primary"
                        //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                        onClick={() => downloadPDF("", "alldata")}
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                      >
                        Export All In Pdf
                      </Button>
                      <Button
                        size="small"
                        disabled={
                          !table.getIsSomeRowsSelected() &&
                          !table.getIsAllRowsSelected()
                        }
                        //only export selected rows
                        onClick={() =>
                          downloadPDF(
                            table.getSelectedRowModel().rows,
                            "selectedrow"
                          )
                        }
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                      >
                        Export Selected Rows in Pdf
                      </Button>
                      {(table.getIsSomeRowsSelected() ||
                        table.getIsAllRowsSelected()) &&
                      checkUserPermission(PERMISSION_DELETE) ? (
                        <Button
                          size="small"
                          // disabled={
                          //   !table.getIsSomeRowsSelected() &&
                          //   !table.getIsAllRowsSelected()
                          // }
                          onClick={() =>
                            handleDeletePopup(
                              "",
                              table.getSelectedRowModel().rows,
                              "multipleRowInactive"
                            )
                          }
                          startIcon={<DeleteIcon />}
                          variant="contained"
                        >
                          Delete
                        </Button>
                      ) : (
                        ""
                      )}

                      {/* <Button
                          size="small"
                          onClick={() =>
                            // setPagination({ ...pagination, pageSize: totalRows })
                            setPagination({
                              ...pagination,
                              pageIndex: 0,
                              pageSize: totalRows,
                            })
                          }
                          variant="contained"
                        >
                          Get All Data
                        </Button> */}
                    </Box>
                  )}
                  muiTableContainerProps={{ sx: { maxHeight: "fit-content" } }}
                  initialState={{
                    density: "compact",
                    // showGlobalFilter: true,

                    expanded: true, //expand all groups by default
                    // grouping: [""], //an array of columns to group by by default (can be multiple)
                    pagination: { pageIndex: 0, pageSize: 25 },
                    // sorting: { id: "Name", desc: false }, //sort by state by default
                  }}
                  // muiToolbarAlertBannerChipProps={{ color: "primary" }}
                  // muiTableContainerProps={{ sx: { maxHeight: 700 } }}

                  //For color of each alternative row
                  // muiTableBodyProps={{
                  //   sx: () => ({
                  //     '& tr:nth-of-type(odd)': {
                  //       backgroundColor: '#E5E5E5'
                  //     }
                  //   })
                  //   }}

                  muiTablePaginationProps={{
                    rowsPerPageOptions: [25, 50, 100, 300],
                  }}
                  //For providing margin to each column
                  // muiTableBodyCellProps={{sx: {borderLeft: '1px solid #E0E0E0'}}}

                  //For providing color to header of table
                  // muiTableHeadCellProps={{
                  //   sx: theme => ({
                  //     background: 'rgba(52, 210, 235, 0.1)',
                  //     borderRight: '1px solid rgba(224,224,224,1)',
                  //     color: theme.palette.text.primary
                  //   })
                  // }}
                  manualFiltering // for termp comment filteron column
                  manualPagination
                  // positionGlobalFilter="left"
                  manualSorting
                  muiToolbarAlertBannerProps={
                    isError
                      ? {
                          color: "error",
                          children: "Error loading data",
                        }
                      : undefined
                  }
                  onColumnFiltersChange={setColumnFilters} // for termp comment filteron column
                  onGlobalFilterChange={setGlobalFilter}
                  onPaginationChange={setPagination}
                  onSortingChange={setSorting}
                  rowCount={rowCount}
                  // enableColumnVirtualization={false}
                  // enableColumnVirtualization
                  state={{
                    columnFilters, // for termp comment filteron column
                    globalFilter,
                    isLoading,
                    pagination,
                    showAlertBanner: isError,
                    showProgressBars: isRefetching,
                    sorting,
                  }}
                />
              </div>

              <div>
                <div className="pull-right">
                  <strong className="mb-0">
                    Total Quantity: {parseFloat(quantity).toFixed(2)}
                  </strong>
                  <br />
                  <strong className="mb-0">
                    Total Amount: {parseFloat(total).toFixed(2)}{" "}
                  </strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="NewRequestDataModal"
        tabIndex={-1}
        aria-labelledby="upset"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-md modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Manage Request</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                {" "}
                <span aria-hidden="true">×</span>{" "}
              </button>
            </div>
            <div className="modal-body">
              <Formik
                {...props}
                initialValues={formValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {({ values, errors, touched, handleChange, handleBlur }) => (
                  <Form>
                    <div className="row">
                      <div className="col-12">
                        <Field
                          type="hidden"
                          className="form-control"
                          id="ID"
                          name="ID"
                          // value={values.ID}
                        />
                        <div className="form-group">
                          <label>
                            Quantity<span className="text-danger">*</span>
                          </label>
                          <Field
                            type="number"
                            name="Quantity"
                            className={`form-control form-control-sm  ${
                              errors.Quantity ? "is-invalid" : ""
                            }`}
                            placeholder="Enter Quantity"
                            id="Quantity"
                            onChange={(e) =>
                              setFormValues({
                                ...formValues,
                                Quantity: e?.target.value,
                              })
                            }
                            // value={formValues.Quantity}
                          />
                          <div className="invalid-feedback">
                            {touched.Quantity && errors.Quantity
                              ? errors.Quantity
                              : ""}
                          </div>
                        </div>
                      </div>
                      <div className="col-12">
                        <Field
                          type="hidden"
                          className="form-control"
                          id="ID"
                          name="ID"
                          // value={values.ID}
                        />
                        <div className="form-group">
                          <label>Price</label>
                          <Field
                            type="number"
                            name="Price"
                            className={`form-control form-control-sm  `}
                            placeholder="Enter Price"
                            id="Price"
                            onChange={(e) =>
                              setFormValues({
                                ...formValues,
                                Price: e?.target.value,
                              })
                            }
                            // value={formValues.Quantity}
                          />
                          {/* <div className="invalid-feedback">
                            {touched.Quantity && errors.Quantity ? errors.Quantity : ""}
                          </div> */}
                        </div>
                      </div>
                      <div className="col-12">
                        <Field
                          type="hidden"
                          className="form-control"
                          id="ID"
                          name="ID"
                          // value={values.ID}
                        />
                        <div className="form-group">
                          <label>Total</label>
                          <input
                            type="number"
                            name="Price"
                            className={`form-control form-control-sm  `}
                            placeholder="Enter Price"
                            id="Price"
                            readOnly
                            value={
                              Number(formValues.Quantity) *
                              Number(formValues.Price)
                            }
                          />
                          {/* <div className="invalid-feedback">
                            {touched.Quantity && errors.Quantity ? errors.Quantity : ""}
                          </div> */}
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="form-group">
                          <label>
                            Customer<span className="text-danger">*</span>
                          </label>
                          <Select
                            options={optionscustomer}
                            // value={selectedoption}
                            isClearable={true}
                            className={`custom-search-select  ${
                              errors.Customer ? "is-invalid" : ""
                            }`}
                            id="Customer"
                            name="Customer"
                            onChange={(e) => {
                              handleSelect(e);
                              formValues.Customer = e?.value;
                            }}
                          />
                          <div className="invalid-feedback">
                            {touched.Customer && errors.Customer
                              ? errors.Customer
                              : ""}
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-12 justify-content-right">
                        <button
                          type="submit"
                          className="btn btn-primary btn-sm me-1 "
                          // className="close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        >
                          {" "}
                          Submit{" "}
                        </button>
                        <Link
                          to="#"
                          className="btn btn-dark btn-sm me-1"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </Link>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
